import { isValid } from "@visactor/vutils";

import { ImageStyle } from "./style/ImageStyle";

import { TextStyle } from "./style/MultilineTextStyle";

import { NumberStyle } from "./style/NumberStyle";

import { Style } from "./style/Style";

import { CheckboxStyle } from "./style/CheckboxStyle";

import { RadioStyle } from "./style/RadioStyle";

const {EVENT_TYPE: EVENT_TYPE} = Style;

export { EVENT_TYPE, Style, NumberStyle, ImageStyle, TextStyle };

export function of(columnStyle, bodyStyle, styleArg, StyleClassDef = Style, globalAutoWrapText, theme) {
    var _a, _b;
    return columnStyle || bodyStyle ? columnStyle instanceof Style ? columnStyle : "function" == typeof columnStyle ? of(columnStyle(styleArg), bodyStyle, styleArg, StyleClassDef, globalAutoWrapText, theme) : (columnStyle || (columnStyle = {}), 
    globalAutoWrapText && !isValid(columnStyle.autoWrapText) && (columnStyle.autoWrapText = !0), 
    StyleClassDef === CheckboxStyle ? new CheckboxStyle(null != columnStyle ? columnStyle : {}, null != bodyStyle ? bodyStyle : {}, null !== (_a = theme.checkboxStyle) && void 0 !== _a ? _a : {}) : StyleClassDef === RadioStyle ? new RadioStyle(null != columnStyle ? columnStyle : {}, null != bodyStyle ? bodyStyle : {}, null !== (_b = theme.radioStyle) && void 0 !== _b ? _b : {}) : new StyleClassDef(null != columnStyle ? columnStyle : {}, null != bodyStyle ? bodyStyle : {})) : StyleClassDef.DEFAULT;
}